export default "__VITE_ASSET__DYoQ9cOr__"